import "./ComponentLayouts.css";
const TwoSectionLayout = ({ leftChildren, rightChildren }) => {
  return (
    <div className="container-fluid TwoSectionLayout">
      <div className="row w-100 mx-auto contentWrapper" >
        <div className="col-md-4 p-0 pe-3 position-relative" >
          <div className="common_shadow rounded p-3 h-100 bg-white">
            {leftChildren}
          </div>
        </div>
        <div className="col-md-8 p-0">{rightChildren}</div>
      </div>
    </div>
  );
};

export default TwoSectionLayout;
